import { createComponent } from '@mtfe/sweet';
import { common, eventBus, dom } from '@mtfe/sweet-utils';

import WelfareCard from '../WelfareCard/script';
import tpl from './dom.html';
import style from './style.less';
import { COUPON_STATUS } from '../constants/index';
import componentUtils from '../utils/index';

const { getGiftEventName, Describe } = componentUtils;

const { isFunction, createUniqueId } = common;

const COMPONENT_ID = 'waimai_9v1p7892';
const SUB_COMPONENT_COUPON_ID = 'waimai_fvrepq4z';
const SUB_COMPONENT_USE_ID = 'waimai_x0vnu2l7';
const SUB_COMPONENT_RECEIVE_ALL_ID = 'waimai_hz0b7h6g';

const describeCouponListC = new Describe('CouponListC', COMPONENT_ID);
const describeCoupon = new Describe('Coupon', SUB_COMPONENT_COUPON_ID);
const describeReceiveAll = new Describe('ReceiveAll', SUB_COMPONENT_RECEIVE_ALL_ID);
const describeUse = new Describe('Use', SUB_COMPONENT_USE_ID);

describeCouponListC.setSubComponent('Coupon', describeCoupon);
describeCouponListC.setSubComponent('ReceiveAll', describeReceiveAll);
describeCouponListC.setSubComponent('Use', describeUse);

const CouponListC = (props = {}) => {
    let { giftInfoList = [] } = props;

    const { welfareIndex, title, subtitle, ignoreCommonCoupon = false, listUniqueId } = props;
    const { btnNameBeforeRecv = '一键领取券包', btnNameAfterRecv = '立即使用' } = props;
    const { onCouponClick, onBatchRecvClick, onBatchUseClick } = props || {};

    const btnIdBeforeRecv = createUniqueId();
    const btnIdAfterRecv = createUniqueId();
    const componentID = createUniqueId();

    // 忽略显示通用红包
    if (ignoreCommonCoupon) {
        giftInfoList = giftInfoList.filter((poiInfo) => !(poiInfo.giftInfo && poiInfo.giftInfo.type === 2));
    }

    // 过滤出未领取的红包
    const newCouponInfos = giftInfoList.filter(
        (item) => item.giftInfo && item.giftInfo.status === COUPON_STATUS.STATUS_NEW,
    );
    // 获取红包id集合
    const giftIds = newCouponInfos.map((item) => item.giftInfo.gift_id);

    const data = {
        COUPON_STATUS,
        giftInfoList,
        btnIdAfterRecv,
        btnNameAfterRecv,
        btnIdBeforeRecv,
        btnNameBeforeRecv,
        hasRecv: giftIds.length === 0,
        listUniqueId,
        componentID,
    };
    // 注册红包Dom更新
    giftInfoList.forEach((poiInfo) => {
        if (poiInfo.giftInfo) {
            const { gift_id: giftId } = poiInfo.giftInfo;
            const eventName = getGiftEventName(giftId);
            eventBus.$on(eventName, (newStatus) => {
                const selector = `.${componentID} [data-gift-id=gift-id${giftId}]`;
                const btnDomList = Array.from(document.querySelectorAll(selector));
                if (btnDomList.length) {
                    btnDomList.forEach((btnDom) => {
                        if (newStatus === COUPON_STATUS.STATUS_NEW) {
                            btnDom.innerText = '领取';
                            poiInfo.giftInfo.status = COUPON_STATUS.STATUS_NEW;
                        } else if (newStatus === COUPON_STATUS.STATUS_RECEIVED) {
                            btnDom.innerText = '去使用';
                            poiInfo.giftInfo.status = COUPON_STATUS.STATUS_RECEIVED;
                        }
                    });
                }
            });
        }
    });
    const events = {
        handleCouponClick(index) {
            if (isFunction(onCouponClick)) {
                onCouponClick(giftInfoList[index], index);
            }
        },
        async handleBatchRecvClick() {
            if (isFunction(onBatchRecvClick)) {
                const result = await onBatchRecvClick(giftIds);
                if (result) {
                    dom.$id(btnIdBeforeRecv).style.display = 'none';
                    dom.$id(btnIdAfterRecv).style.display = 'flex';
                }
            }
        },
        handleBatchUseClick() {
            if (isFunction(onBatchUseClick)) {
                onBatchUseClick();
            }
        },
    };

    const couponListDom = createComponent(tpl, { data, style }, events);

    return WelfareCard({
        title,
        subtitle,
        welfareIndex,
        innerComponent: couponListDom,
    });
};

CouponListC.describe = describeCouponListC;
export default CouponListC;
